import React from "react";

import "./Maintenance.css";

import Button from "@components/Button/Button";

import NavLogo from "@assets/logos/nav-logo4.svg?react";

const STATUS_PAGE_URL = "https://nco-dashboard.statusgator.app/";

export default function Maintenance({onRetry, retrying = false}) {
    return (
        <div className="maintenance-page">
            <NavLogo className="maintenance-logo"/>

            <h1 className="maintenance-title">
                The NetCyberOps Portal is temporarily unavailable. Check our status page for updates.
            </h1>

            <div className="maintenance-actions">
                <Button
                    variant="primary"
                    size="md"
                    onClick={onRetry}
                    disabled={retrying}
                    id="maintenance-retry-btn"
                >
                    {retrying ? "Retrying..." : "Retry"}
                </Button>
                <Button
                    size="md"
                    href={STATUS_PAGE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    id="maintenance-status-btn"
                >
                    Go to status page
                </Button>
            </div>
        </div>
    );
}
